import React from 'react';
import { SxStyle } from '../../../../types';
import { useStringsContext } from '../../../../contexts/strings';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { PlayerMinimized } from '../api-types';
import PlayerAvatar from '../../../common/player-avatar';
import moment from 'moment';

const styles: SxStyle = {
  tableRow: (theme) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.shades.p10,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }),
};

interface Props {
  players: PlayerMinimized[];
  addedPlayers: PlayerMinimized[];
  onAddPlayer: (player: PlayerMinimized) => void;
  onRemovePlayer: (player: PlayerMinimized) => void;
}

const TeamPlayerList = ({ players, addedPlayers, onAddPlayer, onRemovePlayer }: Props) => {
  const { strings } = useStringsContext();

  return (
    <TableContainer>
      <Table size="small">
        <TableBody>
          {players
            .sort((a, b) => a.givenName?.localeCompare(b.givenName))
            .map((player) => (
              <TableRow key={player.fogisId} sx={styles.tableRow}>
                <TableCell>
                  <PlayerAvatar
                    srcImage={player.images?.sefImagePng}
                    fullName={player.givenName + ' ' + player.surName}
                  />
                </TableCell>
                <TableCell>{player.givenName + ' ' + player.surName}</TableCell>
                <TableCell style={{ minWidth: 120 }}>
                  {player.birthDay ? moment(player.birthDay).format('YYYY-MM-DD') : ''}
                </TableCell>
                <TableCell align="right" style={{ minWidth: 180 }}>
                  {addedPlayers.find((addedPlayer) => addedPlayer.fogisId === player.fogisId) ? (
                    <Button
                      variant="contained"
                      color="error"
                      onClick={() => onRemovePlayer(player)}
                      startIcon={<DeleteIcon />}
                    >
                      {strings.squad.remove}
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => onAddPlayer(player)}
                      startIcon={<AddIcon />}
                    >
                      {strings.squad.add}
                    </Button>
                  )}
                </TableCell>
              </TableRow>
            ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TeamPlayerList;
